import { inject, Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/standalone';

/** Promise-based yes/no confirm — replaces the @curbnturf/alert facade for admin actions. */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private readonly alerts = inject(AlertController);

  async confirm(header: string, message = '', confirmText = 'Yes'): Promise<boolean> {
    const alert = await this.alerts.create({
      header,
      message,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        { text: confirmText, role: 'confirm' },
      ],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();
    return role === 'confirm';
  }
}
